import React from 'react'
import { Badge, Nav, NavItem } from 'react-bootstrap'
import { IProgram } from '../../store/program/interfaces'

const NavBadges = (props: {
  program: IProgram
  dateExpired: number
  dateFormatted: JSX.Element
  isTabletOrSmallDesktop: boolean
}) => {
  return (
    <Nav
      className={props.isTabletOrSmallDesktop ? 'd-flex flex-row' : 'ml-auto'}
    >
      <NavItem className='mr-2'>
        <Badge pill variant='secondary'>
          {props.program.distribution_type === 'INSTANT'
            ? 'Sofortbuchung'
            : 'Anmeldung mit Zuteilung'}
        </Badge>
      </NavItem>
      <NavItem>
        {props.dateExpired > 0 ? (
          <Badge pill variant='warning'>
            <>Anmeldeschluss war am {props.dateFormatted}</>
          </Badge>
        ) : (
          <Badge pill variant='success'>
            <>Anmeldeschluss ist am {props.dateFormatted}</>
          </Badge>
        )}
      </NavItem>
    </Nav>
  )
}

export default NavBadges
